/**
 * @surfline/quiver-react v15.0.0 2021-03-09
 */

import 'prop-types';
import React from 'react';
import classNames from 'classnames';
import PremiumRibbonIcon from '../icons/PremiumRibbonIcon/PremiumRibbonIcon.js';

var getFeatureCardClasses = function getFeatureCardClasses(small) {
  return classNames({
    'quiver-feature-card': true,
    'quiver-feature-card--small': small
  });
};

var getFeatureCardTitleContainerClasses = function getFeatureCardTitleContainerClasses(feedSuperheader) {
  return classNames({
    'quiver-feature-card__title__container': true,
    'quiver-feature-card__title__container--hasSuperheader': feedSuperheader
  });
};

var FeatureCard = function FeatureCard(_ref) {
  var imageUrl = _ref.imageUrl,
      onClickLink = _ref.onClickLink,
      small = _ref.small,
      title = _ref.title,
      displayTitle = _ref.displayTitle,
      permalink = _ref.permalink,
      feedSuperheader = _ref.feedSuperheader,
      isPremium = _ref.isPremium;
  return /*#__PURE__*/React.createElement("a", {
    className: getFeatureCardClasses(small),
    href: permalink,
    onClick: onClickLink
  }, isPremium ? /*#__PURE__*/React.createElement(PremiumRibbonIcon, null) : null, /*#__PURE__*/React.createElement("div", {
    className: "quiver-feature-card--inner",
    style: {
      backgroundImage: "url(".concat(imageUrl, ")")
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: getFeatureCardTitleContainerClasses(feedSuperheader)
  }, feedSuperheader && !small ? /*#__PURE__*/React.createElement("div", {
    className: "quiver-feature-card__superheader"
  }, feedSuperheader) : null, /*#__PURE__*/React.createElement("h2", {
    className: "quiver-feature-card__title"
  }, displayTitle || title)));
};

FeatureCard.defaultProps = {
  imageUrl: null,
  small: false,
  displayTitle: null,
  feedSuperheader: null,
  isPremium: false
};

export default FeatureCard;
//# sourceMappingURL=FeatureCard.js.map
